<template>
  <b-table
      :fields="fields"
      :items="items"
      @row-clicked="onClickRow"
      table-class="text-nowrap"
      responsive
      hover
  >
    <template #cell(source)="data">
      <admin-order-badge :text="data.item.order.source.code" :value="data.item.order.source.code" type="source" class="text-uppercase" pill/>
    </template>
    <template #cell(seller)="data">
      <template v-if="data.item.order.seller_license">
        <h4 class="mb-0">{{ data.item.order.seller_license.number }}</h4>
        <span>{{ data.item.order.seller_license.facility.name }}</span>
      </template>
      <template v-else-if="data.item.order.seller_info">
        <h4 class="mb-0">{{ data.item.order.seller_info.license_number }}</h4>
        <span>{{ data.item.order.seller_info.name }}</span>
      </template>
    </template>
    <template #cell(buyer)="data">
      <template v-if="data.item.order.buyer_license">
        <h4 class="mb-0">{{ data.item.order.buyer_license.number }}</h4>
        <span>{{ data.item.order.buyer_license.facility.name }}</span>
      </template>
    </template>
    <template #cell(status)="data">
      <admin-order-badge :text="data.item.order.status.name" :value="data.item.order.status.code" type="status"/>
    </template>
  </b-table>
</template>

<script>
import {convertFromUtc, getFormattedPrice} from "../helpers";
import AdminOrderBadge from "./AdminOrderBadge.vue";

export default {
  name: 'AdminOrdersTable',
  components: {AdminOrderBadge},
  props: {
    orders: Array
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer",
          label: "#"
        },
        {
          key: "source",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "type",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "seller",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "buyer",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "order_date",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer",
          formatter: value => convertFromUtc(value, 'L')
        },
        {
          key: "shipped_date",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer",
          formatter: value => value ? convertFromUtc(value, 'L') : ''
        },
        {
          key: "total",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer",
          formatter: (value) => getFormattedPrice(value)
        },
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
      ]
    }
  },
  computed: {
    items() {
      return this.orders.map(order => ({
        order,
        id: order.id,
        type: order.type.name,
        total: order.price_total,
        order_date: order.created_at,
        shipped_date: order.transfer ? order.transfer.shipped_at : '',
      }));
    }
  },
  methods: {
    getFormattedPrice,
    onClickRow(item) {
      let orderId = item.id;
      this.$router.push({name: "admin-order", params: {id: orderId}});
    }
  }
}
</script>
